export default __webpack_public_path__ + "static/events-logo-2cbb122e629ceab0e76ac47e1f695464.png";